import React from 'react';
import { useEstabStats, useGlobalContext } from '@honeycomb/data';
import { Toasts, toasts, EyeRevealIcon, createToastsStore } from '@honeycomb/ui-core';
import { pluraliseCount } from '../../../utils';
const hotelToastsStore = createToastsStore();
export function HotelUrgencyMessages({ estabId }) {
    var _a, _b;
    const { resourceStrings: { URGENCY_VIEWS_HOTEL_SINGULAR, URGENCY_VIEWS_HOTEL_PLURAL, URGENCY_VIEWS_HOTEL_TRAILING_LABEL, }, configSettings: { UrgencyMessagingNotificationTimeout }, } = useGlobalContext();
    const { data: estabStatsData } = useEstabStats({ estabIds: [parseInt(estabId)] }, []);
    const currentViews = (_b = (_a = estabStatsData === null || estabStatsData === void 0 ? void 0 : estabStatsData.getEstabStats) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.currentViews;
    React.useEffect(() => {
        if (currentViews) {
            // Add the toast
            window.setTimeout(() => {
                toasts.show({
                    id: estabId,
                    message: (React.createElement(React.Fragment, null,
                        React.createElement("strong", null, pluraliseCount(currentViews, {
                            plural: URGENCY_VIEWS_HOTEL_PLURAL,
                            singular: URGENCY_VIEWS_HOTEL_SINGULAR,
                        })),
                        ' ',
                        React.createElement("span", null, URGENCY_VIEWS_HOTEL_TRAILING_LABEL))),
                    position: 'top-start',
                    icon: React.createElement(EyeRevealIcon, null),
                    color: 'primary',
                    autoClose: parseInt(UrgencyMessagingNotificationTimeout),
                }, hotelToastsStore);
            }, 1000);
        }
    }, [
        estabId,
        currentViews,
        URGENCY_VIEWS_HOTEL_PLURAL,
        URGENCY_VIEWS_HOTEL_SINGULAR,
        UrgencyMessagingNotificationTimeout,
        URGENCY_VIEWS_HOTEL_TRAILING_LABEL,
    ]);
    if (!currentViews) {
        return null;
    }
    return React.createElement(Toasts, { store: hotelToastsStore, context: "bound", toastWidth: "auto" });
}
